import { render, staticRenderFns } from "./bnvboolean.vue?vue&type=template&id=58eac34e&"
import script from "./bnvboolean.vue?vue&type=script&lang=js&"
export * from "./bnvboolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports